<template>
  <svg
    :width="size * 1.54"
    :height="size"
    viewBox="0 0 37 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4055 16.1559C12.3615 16.1559 13.6695 14.9679 13.6695 11.9079C13.6695 8.97994 12.5895 7.88794 10.5375 7.88794C8.56947 7.88794 7.26147 9.06394 7.26147 12.1239C7.26147 15.0519 8.35347 16.1559 10.4055 16.1559ZM10.4535 14.8239C9.52947 14.8239 9.03747 14.2479 9.03747 12.0399C9.03747 9.85594 9.56547 9.21994 10.4775 9.21994C11.4015 9.21994 11.9055 9.79594 11.9055 11.9919C11.9055 14.1999 11.3655 14.8239 10.4535 14.8239Z"
      :fill="color"
    />
    <path d="M16.7111 15.9999V14.1759H14.9471V15.9999H16.7111Z" :fill="color" />
    <path
      d="M18.242 12.5079C18.53 12.4599 19.382 12.4239 19.934 12.4239C21.374 12.4239 22.07 12.7359 22.07 13.6599C22.07 14.4519 21.626 14.8599 20.834 14.8599C20.006 14.8599 19.622 14.4759 19.706 13.6839H17.978C17.714 15.3639 18.566 16.1559 20.69 16.1559C22.85 16.1559 23.834 15.1239 23.834 13.5279C23.834 11.7879 22.73 11.1399 20.618 11.1399C20.366 11.1399 20.09 11.1519 19.838 11.1639L19.97 9.54394H23.282L23.414 8.04394H18.53L18.242 12.5079Z"
      :fill="color"
    />
    <path
      d="M29.9645 9.90394H28.2245C28.0205 10.3239 27.8645 10.6719 27.7445 10.9719C27.5165 11.5119 27.3845 11.8839 27.3125 12.0879H27.2885C27.1925 11.7999 27.0485 11.4399 26.7725 10.8879L26.1965 9.80794L24.3965 9.91594L25.9445 12.8919L24.2645 15.9999H26.0165C26.2565 15.5319 26.3885 15.2199 26.5925 14.8119C26.8445 14.2479 27.0365 13.8039 27.0845 13.6239H27.1205C27.1925 13.8639 27.3125 14.1999 27.6965 14.9319L28.3325 16.1079L30.1325 15.9999L28.4645 12.7959L29.9645 9.90394Z"
      :fill="color"
    />
    <mask id="path-2-inside-1" fill="transparent">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      :fill="color"
    />
    <path
      d="M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z"
      :fill="color"
      mask="url(#path-2-inside-1)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
